module.exports = "<gw-heading>{{address}}</gw-heading>\r\n\r\n<div ng-repeat=\"dataItem in scheduledItem.getDataItems()\" class=\"<%= location__data %>\">\r\n    <div class=\"<%= location__dataLabel %>\">{{ dataItem.getPropertyInfo().getLabel() }}</div>\r\n    <gw-schedule-data-item item=\"dataItem\" type=\"readonly-form\"></gw-schedule-data-item>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./common/grunt/webpack/loaders/text-loader!./app/customer/js/src/edge/policycommon/common/directives/schedules/MobileViewGenerator/subdirectives/list/Location/Location.html
// module id = 436
// module chunks = 0